import produce from 'immer'

import {
  FETCH_SKILLS_REQUESTED,
  FETCH_SKILLS_SUCCEED,
  FETCH_SKILLS_FAIL,
} from './actionTypes'


const initialState = {
  isSkillsLoading:true,
  skills:[],
  error: null
}

const SkillErrors = {
  fetchSkillsFailed: 'Не удалось обновить список категорий.'
}

const skillsReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_SKILLS_REQUESTED:
      draft.error = null
      draft.isSkillsLoading = true
      return draft

    case FETCH_SKILLS_SUCCEED:
      draft.skills = action.payload.skills
      draft.isSkillsLoading = false
      return draft

    case FETCH_SKILLS_FAIL:
      draft.error = action.error
      draft.errorText = SkillErrors.fetchSkillsFailed
      return draft

    default:
      return draft
  }
})
export default skillsReducer



// WEBPACK FOOTER //
// ./src/store/skills/reducer.js